import * as Yup from "yup";

export const formSchema = Yup.object().shape({
    phone: Yup
        .string()
        .required('Ta wartość nie powinna być pusta.')
        .matches(/^\d{9}$/, 'Podaj nr\u00a0telefonu w\u00a0formacie 123456789.')
        .max(9),
});